<template>
  <div class="service-list">
    <div
      class="service-list__container"
      :class="{ 'service-list__container--single-column': singleColumn }">
      <!-- :style="{ maxHeight: maxHeight }" -->
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
// Props
  defineProps({
    maxHeight: {
      type: String,
      default: '400px'
    },
    singleColumn: {
      type: Boolean,
      default: false
    }
  })
</script>

<style lang="scss" scoped>
.service-list {
  &__container {
    display: flex;
    flex-flow: row wrap;
    gap: var(--space-s);
    overflow: hidden;

    :deep(.service-list-item) {
      width: calc(50% - (var(--space-s) / 2));
      margin-bottom: 0;
      break-inside: avoid;
    }

    &--single-column :deep(.service-list-item) {
      width: 100%;
    }

    // Responsive: single column on tablet and mobile
    @include mq($until: tablet) {
      :deep(.service-list-item) {
        width: 100%;
      }
    }
  }
}
</style>
